import { API_BASE } from "config/api";
import { withAuthHeaders } from "services/authHeader";
import { apiFetch } from "services/apiFetch";

/* ----------------------------------------------------
   GET basic dashboard stats
---------------------------------------------------- */
export async function getDashboardBasicStats(annotatorId = "", adminId) {
  try {
    const url = new URL("api/dashboard/getDashboardBasicStats", API_BASE);
    if (annotatorId) {
      url.searchParams.append("annotatorId", annotatorId);
    }

    if (adminId) {
      url.searchParams.append("adminId", adminId);
    }

    const res = await apiFetch(url, { headers: withAuthHeaders() });
    const json = await res.json();

    if (json.status === "success") {
      return json.data;
    }

    throw new Error(json.message || "Failed to fetch basic stats");
  } catch (error) {
    console.error("Error in getDashboardBasicStats:", error);
    throw error;
  }
}

/* ----------------------------------------------------
   GET dashboard chart data
---------------------------------------------------- */
export async function getDashboardChartData(annotatorId = "") {
  try {
    const url = new URL("api/dashboard/getDashboardChartData", API_BASE);
    if (annotatorId) {
      url.searchParams.append("annotatorId", annotatorId);
    }

    const res = await apiFetch(url, { headers: withAuthHeaders() });
    const json = await res.json();

    if (json.status === "success") {
      return json.data;
    }

    throw new Error(json.message || "Failed to fetch chart data");
  } catch (error) {
    console.error("Error in getDashboardChartData:", error);
    throw error;
  }
}

/* ----------------------------------------------------
   GET dashboard quality metrics
---------------------------------------------------- */
export async function getDashboardQualityMetrics(annotatorId = "") {
  try {
    const url = new URL("api/dashboard/getDashboardQualityMetrics", API_BASE);
    if (annotatorId) {
      url.searchParams.append("annotatorId", annotatorId);
    }

    const res = await apiFetch(url, { headers: withAuthHeaders() });
    const json = await res.json();

    if (json.status === "success") {
      return json.data;
    }

    throw new Error(json.message || "Failed to fetch quality metrics");
  } catch (error) {
    console.error("Error in getDashboardQualityMetrics:", error);
    throw error;
  }
}
